/**
 * Default get option label fn
 * @param option Option
 */
export const getLabelValueAutoListOptionLabel = <
	T extends {label: string; value: number | string},
>(
	option: T,
) => option?.label ?? '';
